import { Component, inject, signal, ViewChild, ElementRef, AfterViewInit, effect } from '@angular/core';
import { LoadingSpinnerComponent } from "../../shared/components/loading-spinner/loading-spinner.component";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { Tenant } from './models/tenant.model';
import { TenantContextService } from './services/tenant-context.service';
import { OverviewTabComponent } from './tabs/overview-tab/overview-tab.component';
import { DataLakesTabComponent } from './tabs/data-lakes-tab/data-lakes-tab.component';
import { WorkspacesTabComponent } from "./tabs/workspaces-tab/workspaces-tab.component";
import { CatalogsTabComponent } from "./tabs/catalogs-tab/catalogs-tab.component";

@Component({
  selector: 'app-tenant-management',
  standalone: true,
  imports: [
    LoadingSpinnerComponent,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTabsModule,
    MatDialogModule,
    OverviewTabComponent,
    DataLakesTabComponent,
    WorkspacesTabComponent,
    CatalogsTabComponent
],
  templateUrl: './tenant-management.component.html',
  styleUrl: './tenant-management.component.css'
})
export class TenantManagementComponent implements AfterViewInit {
  @ViewChild('overviewBtn', { read: ElementRef }) overviewBtn!: ElementRef;
  @ViewChild('dataLakesBtn', { read: ElementRef }) dataLakesBtn!: ElementRef;
  @ViewChild('workspacesBtn', { read: ElementRef }) workspacesBtn!: ElementRef;
  @ViewChild('catalogsBtn', { read: ElementRef }) catalogsBtn!: ElementRef;

  tenantContextService = inject(TenantContextService);
  private dialog = inject(MatDialog);

  selectedTab = signal<string>('overview');
  errorMessage = signal<string>('');
  indicatorPosition = signal<number>(0);
  indicatorWidth = signal<number>(98);

  ngAfterViewInit(): void {
    // Update tab indicator immediately after view init
    setTimeout(() => this.updateIndicator(), 0);
  }

  private updateIndicator(): void {
    const tab = this.selectedTab();
    let element: HTMLElement | null = null;

    switch(tab) {
      case 'overview':
        element = this.overviewBtn?.nativeElement;
        break;
      case 'dataLakes':
        element = this.dataLakesBtn?.nativeElement;
        break;
      case 'workspaces':
        element = this.workspacesBtn?.nativeElement;
        break;
      case 'catalogs':
        element = this.catalogsBtn?.nativeElement;
        break;
    }

    if (element) {
      this.indicatorPosition.set(element.offsetLeft);
      this.indicatorWidth.set(element.offsetWidth);
    }
  }

  selectTab(tab: string): void {
    this.selectedTab.set(tab);
    this.updateIndicator();
  }

  copyTenantId(): void {
    const tenantId = this.tenantContextService.tenant()?.tenantId;
    if (tenantId) {
      navigator.clipboard.writeText(tenantId);
    }
  }
}
